import EventDocument from './list/event-document';

export const DOCUMENT_FILE_ACTION = { remove: 'remove', upload: 'upload' };

export const assertDocumentResponse = (result) => {
  if (result?.error) throw result.error;
  const { response } = result || {};
  const data = response?.data?.data;
  if (!response || (response.data?.result_code && response.data.result_code !== 'FLSCS')
    || data?.success === false || data?.error) {
    throw new Error(data?.message || response?.data?.result_message || 'Не удалось сохранить файл');
  }
  return result;
};

export const saveEventDocumentFiles = async ({ files, initial, limit, upload, remove, onProgress = () => {}, isActive = () => true }) => {
  const desired = EventDocument.normalizeFiles(files);
  const capacity = EventDocument.getDocCount({ doc_count: limit });
  let saved = [...EventDocument.normalizeFiles(initial)];
  if (desired.length > capacity) throw new Error('Превышено максимальное количество файлов');
  const desiredKeys = new Set(desired.map(EventDocument.fileKey));
  const savedKeys = new Set(saved.map(EventDocument.fileKey));
  const additions = desired.filter((file) => !savedKeys.has(EventDocument.fileKey(file)));
  const replacing = capacity === 1 && additions.length > 0;
  const removals = replacing ? [] : saved.filter((file) => !desiredKeys.has(EventDocument.fileKey(file)));
  const actions = [
    ...removals.map((file) => ({ type: DOCUMENT_FILE_ACTION.remove, file })),
    ...additions.map((file) => ({ type: DOCUMENT_FILE_ACTION.upload, file })),
  ];
  const methods = {
    [DOCUMENT_FILE_ACTION.remove]: remove,
    [DOCUMENT_FILE_ACTION.upload]: upload,
  };
  await actions.reduce(async (previous, action) => {
    await previous;
    if (!isActive()) throw new Error('Сохранение отменено');
    const result = assertDocumentResponse(await methods[action.type](action.file));
    let uploaded;
    if (action.type === DOCUMENT_FILE_ACTION.remove) {
      saved = saved.filter((file) => EventDocument.fileKey(file) !== EventDocument.fileKey(action.file));
    } else {
      uploaded = result.item || result.response.data.data;
      if (!uploaded?.id) throw new Error('Сервер не вернул сохранённый файл');
      saved = replacing ? [uploaded] : [...saved, uploaded];
    }
    if (isActive()) onProgress({ files: [...saved], action, uploaded });
  }, Promise.resolve());
  return saved;
};
